module.exports = __webpack_public_path__ + "static/media/GoodMorning_Part1.a8d5af3e.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/GoodMorning/GoodMorning_Part1.mp3
// module id = 140
// module chunks = 0